// extracted by mini-css-extract-plugin
export default {"ValueContainer":"uYNXseLo"};